"use strict";

import angular from "angular";

import template from "./share-confirm.component.html";
import "./themes/share-confirm.component.scss";

export class rememberSharedComponent {
    constructor($mdDialog) {
        this.$mdDialog = $mdDialog;
    }
    $onInit() {}
}
rememberSharedComponent.$inject = ["$mdDialog"];

const name = "rememberSharedComponent";
const def = {
    controller: rememberSharedComponent,
        bindings: { imageUrl: "<" },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
